
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[profileuser]/work-for-us",
      function () {
        return require("private-next-pages/[profileuser]/work-for-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[profileuser]/work-for-us"])
      });
    }
  